(function () {
  var pathLocale = window.location.pathname.match(/^\/(en|fr|it)(?:\/|$)/i);
  var locale = pathLocale
    ? pathLocale[1].toLowerCase()
    : (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);

  var exactReplacements = {
    de: {
      'Für den Versand berechnen wir eine Versandpauschale von CHF 4.95 pro Bestellung.': 'Der Standardversand kostet CHF 6.95 pro Bestellung. Ab CHF 120.– ist der Versand kostenlos.',
      'Die Versandkosten betragen CHF 4.95 für alle Bestellungen innerhalb der Schweiz.': 'Der Standardversand kostet CHF 6.95 innerhalb der Schweiz und Liechtenstein. Ab CHF 120.– ist der Versand kostenlos.',
      'Nein, wir berechnen einheitlich CHF 4.95 Versandkosten. Unsere tatsächlichen Versandkosten mit Swiss Post Express sind deutlich höher, weshalb wir die Differenz selbst tragen. Wir versenden damit faktisch mit Verlust, um Ihnen faire Gesamtpreise bieten zu können.': 'Ja. Ab CHF 120.– ist der Versand kostenlos. Bei Bestellungen unter CHF 120.– kostet der Standardversand CHF 6.95.'
    },
    en: {
      'Shipping is charged at a flat rate of CHF 4.95 per order.': 'Standard shipping costs CHF 6.95 per order. Shipping is free from CHF 120.–.',
      'Shipping costs CHF 4.95 for all orders within Switzerland.': 'Standard shipping costs CHF 6.95 within Switzerland and Liechtenstein. Shipping is free from CHF 120.–.',
      'No. We charge a flat shipping rate of CHF 4.95. Our actual Swiss Post Express shipping costs are considerably higher, and we cover the difference ourselves in order to keep the total cost fair for you.': 'Yes. Shipping is free from CHF 120.–. For orders below CHF 120.–, standard shipping costs CHF 6.95.'
    },
    fr: {
      'Les frais de livraison sont facturés au tarif forfaitaire de CHF 4.95 par commande.': 'La livraison standard coûte CHF 6.95 par commande. La livraison est gratuite dès CHF 120.–.',
      'Les frais de livraison sont de CHF 4.95 pour toutes les commandes en Suisse.': 'La livraison standard coûte CHF 6.95 en Suisse et au Liechtenstein. La livraison est gratuite dès CHF 120.–.',
      'Non. Nous appliquons un tarif de livraison fixe de CHF 4.95. Nos frais réels d’expédition avec Swiss Post Express sont nettement plus élevés et nous prenons la différence à notre charge afin de maintenir un coût total équitable pour vous.': 'Oui. La livraison est gratuite dès CHF 120.–. Pour les commandes inférieures à CHF 120.–, la livraison standard coûte CHF 6.95.'
    },
    it: {
      'Per la spedizione applichiamo una tariffa fissa di CHF 4.95 per ordine.': 'La spedizione standard costa CHF 6.95 per ordine. La spedizione è gratuita da CHF 120.–.',
      'Le spese di spedizione sono pari a CHF 4.95 per tutti gli ordini in Svizzera.': 'La spedizione standard costa CHF 6.95 in Svizzera e Liechtenstein. La spedizione è gratuita da CHF 120.–.',
      'No. Applichiamo una tariffa di spedizione fissa di CHF 4.95. I nostri costi effettivi di spedizione con Swiss Post Express sono sensibilmente più elevati e ci facciamo carico della differenza per mantenere un costo complessivo equo per Lei.': 'Sì. La spedizione è gratuita da CHF 120.–. Per ordini inferiori a CHF 120.–, la spedizione standard costa CHF 6.95.'
    }
  };

  var productShipping = {
    de: {
      headings: ['versand & lieferung', 'versand und lieferung'],
      note: 'Standardversand CHF 6.95. Kostenloser Versand ab CHF 120.–.'
    },
    en: {
      headings: ['shipping & delivery', 'shipping and delivery'],
      note: 'Standard shipping CHF 6.95. Free shipping from CHF 120.–.'
    },
    fr: {
      headings: ['expédition & livraison', 'expédition et livraison', 'livraison & expédition'],
      note: 'Livraison standard CHF 6.95. Livraison gratuite dès CHF 120.–.'
    },
    it: {
      headings: ['spedizione e consegna', 'spedizione & consegna'],
      note: 'Spedizione standard CHF 6.95. Spedizione gratuita da CHF 120.–.'
    }
  };

  var policyShipping = {
    de: {
      title: 'Versandinformationen',
      sections: [
        {
          heading: 'Schnelle Lieferung in die Schweiz und nach Liechtenstein',
          body: 'Bestellungen, die an Werktagen bis 14:00 Uhr eingehen, werden in der Regel noch am selben Tag mit Swiss Post Express versandt. Die Zustellung erfolgt üblicherweise innerhalb von 1–2 Werktagen.'
        },
        {
          heading: 'Liefergebiet',
          body: 'Wir liefern ausschliesslich innerhalb der Schweiz und nach Liechtenstein. Lieferungen an Adressen ausserhalb dieser Gebiete sind derzeit nicht möglich.'
        },
        {
          heading: 'Versandkosten',
          body: 'Der Standardversand kostet CHF 6.95 pro Bestellung, unabhängig von der Anzahl der bestellten Produkte. Ab CHF 120.– ist der Versand kostenlos.'
        },
        {
          heading: 'Bestellabwicklung und Versandzeiten',
          body: 'Bestellungen bis 14:00 Uhr an Werktagen werden in der Regel am selben Tag bearbeitet und versandt. Bestellungen nach 14:00 Uhr sowie Bestellungen an Wochenenden oder Feiertagen werden am nächsten Werktag bearbeitet.'
        },
        {
          heading: 'Lieferzeiten',
          body: 'Die übliche Lieferzeit beträgt 1–2 Werktage nach Versand. Die angegebenen Lieferzeiten sind Richtwerte und können je nach Zustellgebiet, Feiertagen oder Auslastung der Post abweichen.'
        },
        {
          heading: 'Lieferadresse und Zustellung',
          body: 'Die Bestellung wird an die an der Kasse angegebene Lieferadresse versandt. Bitte prüfen Sie, dass Name, Strasse, Hausnummer, Postleitzahl und Ort vollständig und korrekt angegeben sind. Unvollständige oder fehlerhafte Adressangaben können zu Verzögerungen oder einer Rücksendung führen.'
        }
      ]
    },
    en: {
      title: 'Shipping information',
      sections: [
        {
          heading: 'Fast delivery across Switzerland and Liechtenstein',
          body: 'Orders received by 14:00 on working days are normally dispatched the same day with Swiss Post Express. Delivery usually takes 1–2 working days.'
        },
        {
          heading: 'Delivery area',
          body: 'We deliver exclusively within Switzerland and Liechtenstein. Delivery to addresses outside these areas is currently not available.'
        },
        {
          heading: 'Shipping costs',
          body: 'Standard shipping costs CHF 6.95 per order, regardless of the number of products ordered. Shipping is free from CHF 120.–.'
        },
        {
          heading: 'Order processing and dispatch',
          body: 'Orders placed by 14:00 on working days are normally processed and dispatched the same day. Orders placed after 14:00, at weekends or on public holidays are processed on the next working day.'
        },
        {
          heading: 'Delivery times',
          body: 'The usual delivery time is 1–2 working days after dispatch. Delivery times are estimates and may vary depending on the delivery area, public holidays or Swiss Post capacity.'
        },
        {
          heading: 'Delivery address and receipt',
          body: 'Orders are sent to the delivery address provided at checkout. Please make sure the recipient name, street, house number, postcode and town are complete and correct. Incomplete or incorrect address details may result in delays or the parcel being returned.'
        }
      ]
    },
    fr: {
      title: 'Informations de livraison',
      sections: [
        {
          heading: 'Livraison rapide en Suisse et au Liechtenstein',
          body: 'Les commandes reçues avant 14 h les jours ouvrables sont généralement expédiées le jour même avec Swiss Post Express. La livraison prend habituellement 1 à 2 jours ouvrables.'
        },
        {
          heading: 'Zone de livraison',
          body: 'Nous livrons exclusivement en Suisse et au Liechtenstein. La livraison à des adresses situées en dehors de ces territoires n’est actuellement pas proposée.'
        },
        {
          heading: 'Frais de livraison',
          body: 'La livraison standard coûte CHF 6.95 par commande, quel que soit le nombre de produits commandés. La livraison est gratuite dès CHF 120.–.'
        },
        {
          heading: 'Traitement des commandes et expédition',
          body: 'Les commandes passées avant 14 h les jours ouvrables sont généralement traitées et expédiées le jour même. Les commandes passées après 14 h, pendant le week-end ou un jour férié sont traitées le jour ouvrable suivant.'
        },
        {
          heading: 'Délais de livraison',
          body: 'Le délai de livraison habituel est de 1 à 2 jours ouvrables après l’expédition. Ces délais sont indicatifs et peuvent varier selon la région de livraison, les jours fériés ou la charge de Swiss Post.'
        },
        {
          heading: 'Adresse et réception de la commande',
          body: 'La commande est envoyée à l’adresse de livraison indiquée lors du paiement. Veuillez vérifier que le nom du destinataire, la rue, le numéro, le code postal et la localité sont complets et corrects. Des informations incomplètes ou incorrectes peuvent entraîner un retard ou le retour du colis.'
        }
      ]
    },
    it: {
      title: 'Informazioni sulla spedizione',
      sections: [
        {
          heading: 'Consegna rapida in Svizzera e Liechtenstein',
          body: 'Gli ordini ricevuti entro le 14:00 nei giorni lavorativi vengono normalmente spediti lo stesso giorno con Swiss Post Express. La consegna richiede in genere 1–2 giorni lavorativi.'
        },
        {
          heading: 'Area di consegna',
          body: 'Effettuiamo consegne esclusivamente in Svizzera e Liechtenstein. Al momento non sono disponibili spedizioni verso indirizzi situati al di fuori di queste aree.'
        },
        {
          heading: 'Costi di spedizione',
          body: 'La spedizione standard costa CHF 6.95 per ordine, indipendentemente dal numero di prodotti ordinati. La spedizione è gratuita da CHF 120.–.'
        },
        {
          heading: 'Elaborazione degli ordini e spedizione',
          body: 'Gli ordini effettuati entro le 14:00 nei giorni lavorativi vengono normalmente elaborati e spediti lo stesso giorno. Gli ordini effettuati dopo le 14:00, durante il fine settimana o nei giorni festivi vengono elaborati il giorno lavorativo successivo.'
        },
        {
          heading: 'Tempi di consegna',
          body: 'Il tempo di consegna abituale è di 1–2 giorni lavorativi dalla spedizione. I tempi indicati sono stime e possono variare in base alla zona di consegna, ai giorni festivi o al carico di lavoro di Swiss Post.'
        },
        {
          heading: 'Indirizzo e ricezione della consegna',
          body: 'L’ordine viene spedito all’indirizzo indicato al momento del pagamento. Verifichi che nome del destinatario, via, numero civico, codice postale e località siano completi e corretti. Dati incompleti o errati possono causare ritardi o la restituzione del pacco.'
        }
      ]
    }
  };

  var shippingTerms = /shipping|delivery|versand|lieferung|livraison|expédition|spedizione|consegna/i;
  var replacements = exactReplacements[locale] || exactReplacements.en;
  var productCopy = productShipping[locale] || productShipping.en;
  var policyCopy = policyShipping[locale] || policyShipping.en;
  var applying = false;

  function updateTextNode(node) {
    if (!node || !node.nodeValue || !node.parentElement) return;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|OPTION)$/.test(node.parentElement.tagName)) return;

    var original = node.nodeValue;
    var trimmed = original.trim();
    if (!trimmed) return;

    var replacement = replacements[trimmed];
    if (replacement) {
      var leading = original.match(/^\s*/)[0];
      var trailing = original.match(/\s*$/)[0];
      node.nodeValue = leading + replacement + trailing;
      return;
    }

    if (trimmed.indexOf('CHF 4.95') === -1) return;

    var context = node.parentElement.closest('details, .sn-collection-service, .sn-announcement, [class*="shipping"], [class*="delivery"], [class*="versand"], [class*="livraison"], [class*="spedizione"]');
    var contextText = context ? context.textContent : node.parentElement.textContent;

    if (shippingTerms.test(trimmed) || shippingTerms.test(contextText || '')) {
      node.nodeValue = original.replace(/CHF 4\.95/g, 'CHF 6.95');
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function updateShippingPolicy() {
    if (!/\/policies\/shipping-policy(?:\/|$)/i.test(window.location.pathname)) return;

    var title = document.querySelector('.shopify-policy__title h1') || document.querySelector('.shopify-policy__container h1');
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;

    if (title && title.textContent.trim() !== policyCopy.title) {
      title.textContent = policyCopy.title;
    }

    if (body.getAttribute('data-sn-shipping-locale') === locale) return;

    var html = policyCopy.sections.map(function (section) {
      return '<h2>' + escapeHtml(section.heading) + '</h2><p>' + escapeHtml(section.body) + '</p>';
    }).join('');

    body.innerHTML = html;
    body.setAttribute('data-sn-shipping-locale', locale);
  }

  function addProductShippingNote(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var details = scope.querySelectorAll('.product__accordion details');

    details.forEach(function (detail) {
      var summary = detail.querySelector('summary');
      var content = detail.querySelector('.accordion__content');
      if (!summary || !content || content.hasAttribute('data-sn-product-shipping')) return;

      var heading = summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var isShipping = productCopy.headings.some(function (candidate) {
        return heading.indexOf(candidate) !== -1;
      });

      if (!isShipping || content.querySelector('.sn-shipping-pricing-note')) return;
      if (content.textContent.indexOf('CHF 6.95') !== -1 && content.textContent.indexOf('CHF 120') !== -1) return;

      var paragraph = document.createElement('p');
      paragraph.className = 'sn-shipping-pricing-note';
      paragraph.textContent = productCopy.note;
      content.appendChild(paragraph);
    });
  }

  function updateRoot(root) {
    if (!root || applying) return;
    applying = true;

    if (root.nodeType === Node.TEXT_NODE) {
      updateTextNode(root);
    } else {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(updateTextNode);
      addProductShippingNote(root);
      updateShippingPolicy();
    }

    applying = false;
  }

  function run() {
    updateRoot(document.body);
    addProductShippingNote(document);
    updateShippingPolicy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    if (applying) return;
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') updateTextNode(mutation.target);
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE) updateRoot(node);
      });
    });
    updateShippingPolicy();
  });

  function startObserver() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(run, 250);
    window.setTimeout(run, 1000);
  }

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, { once: true });
})();